import { useDispatch, useSelector } from 'react-redux';

import { selectAnnouncementCompanyKey } from 'redux/selectors/general';
import { clearAnnouncementSeen } from 'redux/slices/general';
import { resetSidebarTourDismissal } from 'redux/slices/sidebarTour';

import { TOUR_ID } from '../constants';

// Starts the sidebar tour again, whether it was finished, skipped or closed with Esc.
export default function useReplayTour() {
    const dispatch = useDispatch();
    const companyKey = useSelector(selectAnnouncementCompanyKey);

    return () => {
        dispatch(resetSidebarTourDismissal());
        dispatch(clearAnnouncementSeen({ companyKey, id: TOUR_ID }));
    };
}
